import React from 'react';
import { Container } from 'react-bootstrap-5';
import PageHeaderHeading from './page_header_heading';
import PageHeaderActions from './page_header_actions';
import PageHeaderCount from './page_header_count';
import PageHeaderSubheader from './page_header_subheader';
import { PageHeaderBandContext } from './band_context';
import { inOsNavShell } from 'components/buildout_os_display';
import classNames from 'classnames';

interface Props {
  band?: boolean;
  children?: React.ReactNode;
  className?: string;
  containerFluid?: string;
  containerWidth?: boolean;
}

// band: a page opened from the Buildout OS sidebar. Inside the OS nav it gets the prototype's header band;
// anywhere else it stays the classic header.
export default function PageHeader({
  band = false, children, className, containerFluid, containerWidth = false,
}: Props) {
  const inBand = band && inOsNavShell();
  const childArray = React.Children.toArray(children);
  const subheader = childArray.find(
    child => React.isValidElement(child) && child.type === PageHeaderSubheader
  );
  const mainChildren = childArray.filter(
    child => !(React.isValidElement(child) && child.type === PageHeaderSubheader)
  );
  const padding = inBand ? 'py-3 px-4' : 'p-4';
  const mainRow = (
    <div className={classNames('d-flex justify-content-between align-items-center', { 'gap-3': inBand })}>
      {mainChildren}
    </div>
  );

  if (containerWidth) {
    return (
      <PageHeaderBandContext.Provider value={inBand}>
        <div className={classNames('bg-white border-bottom shadow', className)}>
          <div className={classNames(padding, { 'border-bottom': subheader })}>
            <Container fluid={containerFluid}>
              {mainRow}
            </Container>
          </div>
          {subheader && (
            <div className="px-4">
              <Container>
                <div className="d-flex justify-content-between align-items-center">
                  {subheader}
                </div>
              </Container>
            </div>
          )}
        </div>
      </PageHeaderBandContext.Provider>
    );
  }

  return (
    <PageHeaderBandContext.Provider value={inBand}>
      <div className={classNames('bg-white border-bottom shadow', className)}>
        <div className={classNames(padding, { 'border-bottom': subheader })}>
          {mainRow}
        </div>
        {subheader && (
          <div className="px-4">
            <div className="d-flex justify-content-between align-items-center">
              {subheader}
            </div>
          </div>
        )}
      </div>
    </PageHeaderBandContext.Provider>
  );
}

PageHeader.Heading = PageHeaderHeading;
PageHeader.Actions = PageHeaderActions;
PageHeader.Count = PageHeaderCount;
PageHeader.Subheader = PageHeaderSubheader;
